import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const NewAccordion = ({ title = "More Info", children }) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  return (
    <Accordion
    expanded={expanded}
    onChange={handleChange}
    sx={{
      margin: 0,
      borderBottom: '1px solid #FAE1C3',
        boxShadow: 'none', 
        '&:before': {
          display: 'none',
        },
    }}
   >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ fontSize: expanded? 28: 24 }} />}
        aria-controls="panel-content"
        id="panel-header"
      >
        <Typography
          sx={{
            fontWeight: expanded ? 700 : 400,
            fontSize: '16px',
            fontFamily: 'Scandinavian New',
            transition: 'font-weight 0.1s ease',
            lineHeight: '24px',
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography sx={{ fontSize: '16px', fontFamily: 'Scandinavian New', lineHeight:'24px' }}>{children}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default NewAccordion;
